<template>
  <section>
    <div class="left">
      <h2 v-translate>Nastavení uživatelských profilů</h2>
    </div>
    <div class="right">
      <div class="field_left">
        <checkbox-input
            v-if="isOperator"
            :disabled="!isEditable"
            id="allow_child_subscriber_profiles"
            v-model="entity.allow_child_subscriber_profiles"
        >
          <translate class="translate">Povolit vytvářet dětské uživatelské profily</translate>
        </checkbox-input>
        <select-box
            v-if="isOperator"
            id="subscriber_profile_images"
            :options="operatorOverringSettingsOptions"
            v-model="entity.subscriber_profile_images"
            :disabled="!isEditable"
            ref="subscriberprofileimagesref"
        >
          <translate class="translate">Obrázky uživatelských profilů</translate>
        </select-box>
        <div>&nbsp;</div>
        <select-box
            id="create_default_child_subscriber_profile"
            :options="nullableBooleanOptions"
            v-model="createDefaultChildSubscriberProfile"
            :disabled="childProfileDisabled"
            ref="createdefaultchildsubscriberprofileref"
            :help-text="$gettextInterpolate($gettext(helptext),{ value: adminCreateDefaultChildProfileValueText })"
        >
          <translate class="translate">Vytvářet výchozí dětský profil</translate>
        </select-box>
        <checkbox-input
            v-if="isOperator"
            :disabled="!isEditable"
            id="subscriber_profile_autoselect_on_new_device"
            v-model="entity.subscriber_profile_autoselect_on_new_device"
        >
          <translate class="translate">Automaticky předvybrat poslední použitý profil u nových zařízení</translate>
        </checkbox-input>
      </div>
      <div class="field_right">
        <text-input
            id="default_subscriber_profile_name"
            v-model="entity.default_subscriber_profile_name"
            :disabled="!isEditable"
            ref="defaultsubscriberprofilenameref"
            :help-text="$gettextInterpolate($gettext(helptext),{ value: entity.admin_default_subscriber_profile_name })"
        ><translate class="translate">Název výchozího uživatelského profilu</translate></text-input>
        <text-input
            id="default_child_subscriber_profile_name"
            v-model="entity.default_child_subscriber_profile_name"
            :disabled="childProfileDisabled"
            ref="defaultchildsubscriberprofilenameref"
            :help-text="$gettextInterpolate($gettext(helptext),{ value: entity.admin_default_child_subscriber_profile_name })"
        ><translate class="translate">Název výchozího dětského uživatelského profilu</translate></text-input>
      </div>
    </div>
  </section>
</template>
<script>
import {getCorrectBooleanValue} from "@/utils/helpers"

export default {
  name: "SubscriberProfileForm",
  props: {
    entity: Object,
    isOperator: Boolean,
    isEditable: Boolean,
  },
  computed:{
    nullableBooleanOptions() {
      return [
        {id: null, text: this.$gettext('Neurčeno')},
        {id: true, text: this.$gettext('Ano')},
        {id: false, text: this.$gettext('Ne')},
      ]
    },
    childProfileDisabled(){
      if(this.isOperator){
        return !this.entity.allow_child_subscriber_profiles && this.isEditable;
      }else{
        return this.isEditable;
      }
    },
    operatorOverringSettingsOptions(){
      return [
        {id: 'owners', text: this.$gettext('Výchozí')},
        {id: 'owners_and_operators', text: this.$gettext('Výchozí a operátorské')},
        {id: 'operators', text: this.$gettext('Pouze operátorské')},
      ]
    },
    createDefaultChildSubscriberProfile:{
      get() {
        return this.entity.create_default_child_subscriber_profile
      },
      set(newValue) {
        this.entity.create_default_child_subscriber_profile = getCorrectBooleanValue(newValue)
      }
    },
    helptext(){
      return this.isOperator
        ? this.$gettext('Hodnota nastavení business modelu/platformy: %{value}')
        : this.$gettext('Hodnota nastavení platformy: %{value}')
    },
    adminCreateDefaultChildProfileValueText(){
      return this.entity.admin_create_default_child_subscriber_profile ? this.$gettext('Ano') : this.$gettext('Ne');
    }
  },
  watch: {
    "entity.allow_child_subscriber_profiles"(newVal) {
      if(!newVal){
        this.entity.create_default_child_subscriber_profile = false;
        this.entity.default_child_subscriber_profile_name = null;
      }
    }
  }
}

</script>


// WEBPACK FOOTER //
// src/components/views/businessModels/Forms/SubscriberProfileForm.vue